import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import ReglaCreate from './ReglaCreate';
import ReglaList from './ReglaList';
import ReglaEdit from './ReglaEdit';
import ReglaShow from './ReglaShow';

const indexRegla = {
    icon: CheckCircleIcon,
    list: ReglaList,
    create: ReglaCreate,
    edit: ReglaEdit,
    show: ReglaShow,
};

export default indexRegla;
